import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SpecimenListPage } from '@/features/product/pages/SpecimenListPage';
import { specimenListSearchSchema } from '@/features/product/types/product.types';

export const Route = createFileRoute('/_auth/product/specimen-list-view')({
  validateSearch: specimenListSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Specimen List View">
      <Suspense fallback={<PageLoader />}>
        <SpecimenListPage
          routeId="specimenListView"
          readOnly={true}
          shouldHideEarlySpecimens={true}
        />
      </Suspense>
    </ErrorBoundary>
  ),
});
